import domtoimage from 'dom-to-image';

/**
 * Generates a downloadable image from bird's eye map
 * 
 * @author Patrik Larsen <patrik.larsen@kvanttori.fi>
 * @author Nevil Sandaradura <nevil.sandaradura@kvanttori.fi>
 */

const generateSvg = async (fileName: string) => {
  const chartElementRef = document.getElementById('be_chart');
  if (!chartElementRef) {
    console.error("Failed getting birds-eye chart element ref!");
    return;
  }
  const generatedSvg = await domtoimage.toSvg(chartElementRef);
  downloadImage(generatedSvg, fileName);
};

const downloadImage = async (imageSrc: string, fileName: string) => {
  const image = await fetch(imageSrc);
  const imageBlog = await image.blob();
  const imageURL = URL.createObjectURL(imageBlog);

  const link = document.createElement('a');
  link.href = imageURL;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default generateSvg;